import { WEB_COMPONENT_SELECT_COMPANY_INTEGRATION } from '../../webcomponents.constants';
import { IntegrationSelectCompanyWebComponent } from './component/IntegrationSelectCompanyWebComponent';

export { IntegrationSelectCompanyWebComponent };

window.customElements.define(WEB_COMPONENT_SELECT_COMPANY_INTEGRATION, IntegrationSelectCompanyWebComponent);
